<h2 mat-dialog-title class="dialog-title">
  {{ data.mode === 'create' ? 'Neue Maßnahme' : 'Maßnahme bearbeiten' }}
</h2>

<mat-dialog-content class="mat-typography dialog-content">
  <!-- Loading indicator -->
  <div *ngIf="loading" class="loading-container">
    <p>Lade Daten...</p>
  </div>
  
  <form [formGroup]="massnahmeForm" *ngIf="!loading">
    <!-- Beschreibung -->
    <div class="form-group">
      <label class="form-label" for="beschreibung">Beschreibung *</label>
      <textarea
        id="beschreibung"
        formControlName="beschreibung"
        rows="3"
        class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Beschreibung der Maßnahme"></textarea>
    </div>

    <!-- Sortierung -->
    <div class="form-group">
      <label class="form-label" for="sortierung">Sortierung *</label>
      <input
        type="number"
        class="form-control"
        id="sortierung"
        formControlName="sortierung"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Sortierung" />
    </div>

    <!-- Status ID -->
    <div class="form-group">
      <label class="form-label" for="status_id">Status ID *</label>
      <input
        type="number"
        class="form-control"
        id="status_id"
        formControlName="status_id"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Status ID" />
    </div>

    <!-- Indikator ID -->
    <div class="form-group">
      <label class="form-label" for="indikator_id">Indikator ID *</label>
      <input
        type="number"
        class="form-control"
        id="indikator_id"
        formControlName="indikator_id"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Indikator ID" />
    </div>

    <!-- Checkboxes -->
    <div class="form-group">
      <label class="form-label">Optionen</label>
      <div class="checkbox-group">
        <label class="checkbox-label">
          <input type="checkbox" formControlName="druck_auf_bericht" class="checkbox-input">
          <span class="checkbox-text">Druck auf Bericht</span>
        </label>
      </div>
      
      <div class="checkbox-group">
        <label class="checkbox-label">
          <input type="checkbox" formControlName="foto_erforderlich" class="checkbox-input">
          <span class="checkbox-text">Foto erforderlich</span>
        </label>
      </div>
      
      <div class="checkbox-group">
        <label class="checkbox-label">
          <input type="checkbox" formControlName="freigeben" class="checkbox-input">
          <span class="checkbox-text">Freigeben</span>
        </label>
      </div>
      
      <div class="checkbox-group">
        <label class="checkbox-label">
          <input type="checkbox" formControlName="fertig_setzen" class="checkbox-input">
          <span class="checkbox-text">Fertig setzen</span>
        </label>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Abbrechen</button>
  <button mat-button (click)="onSubmit()" cdkFocusInitial>Speichern</button>
</mat-dialog-actions>
